import { ToggleButton, ToggleButtonGroup } from '@mui/material';

interface CredToggleOption {
  value: string;
  label: string;
}

interface CredToggleProps {
  value: string;
  options: CredToggleOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
  sx?: object;
}

const toggleBtnSx = {
  textTransform: 'none' as const,
  fontSize: '13px',
  py: 0.5,
  px: 2,
  border: '1px solid #ddd',
  '&.Mui-selected': { bgcolor: '#f5f5f5', fontWeight: 'bold' },
};

export const CredToggle = ({ value, options, onChange, disabled, sx }: CredToggleProps) => (
  <ToggleButtonGroup
    value={value}
    exclusive
    onChange={(_e, val) => {
      if (val) onChange(val);
    }}
    size="small"
    sx={{ mb: 2, ...sx }}
    disabled={disabled}
  >
    {options.map((opt) => (
      <ToggleButton key={opt.value} value={opt.value} sx={toggleBtnSx}>
        {opt.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);
